// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"34a2677c","732":"f8e76ecd","977":"4f05d7de"}[chunkId] + ".chunk.js";
};